export function isFirstPageVisitAfterLogin() {
    const queryString = window.location.search;
    return queryString && queryString.includes('initpage=1');
}

export function tryRemovePageReloadFlag() {
    const KEY = 'bldm.pagereloadflag';

    if (window.localStorage.getItem(KEY)) {
        window.localStorage.removeItem(KEY);
        return true;
    }
    return false;
}

export function reloadPage() {
    const KEY = 'bldm.pagereloadflag';

    if (tryRemovePageReloadFlag(KEY) === false) {
        window.localStorage.setItem(KEY, String(true));
        window.location.reload();
    }
}
